import sortBy from "utils/sortBy"

const addToArticle = (article, contentfulAdPlacements) => {
  const { id: articleId, tags } = article

  const currentDate = new Date()

  const adGroups = contentfulAdPlacements
    ?.filter((adGroup) => {
      const { startDate, endDate, pages, targetArticles, targetTags } = adGroup
      return (
        pages.includes("Article") &&
        (!startDate || new Date(startDate) <= currentDate) &&
        (!endDate || new Date(endDate) >= currentDate) &&
        (targetArticles?.some((id) => Number(id) === Number(articleId)) ||
          targetTags?.some((tag) => (tags ? tags.includes(tag) : false)))
      )
    })
    .map((adGroup) => ({ ...adGroup, adCount: adGroup.adUnits.length }))

  article.contentfulAdUnits = null
  if (!adGroups || !adGroups.length) {
    return
  }
  article.contentfulAdUnits = sortBy(adGroups, "adCount").pop()?.adUnits || null
}

export default { addToArticle }
